import { combineReducers } from 'redux'
import { BooleanRecord } from '../../types/UtilityTypes'
import { createAction, createReducer } from 'typesafe-actions'
import { User } from '../../responses/users'
import { array, filter } from 'fp-ts/Array'
import { fromFoldableMap } from 'fp-ts/Record'
import { pipe } from 'fp-ts/function'
import { getLastSemigroup } from 'fp-ts/Semigroup'
import { userActions } from '../global/user/user-actions'
import { projectActions } from './project/project-actions'

export const usersActions = {
    update: createAction('@USERS_ACTIONS/UPDATE')<User[]>()
}

export interface UsersState {
    online: BooleanRecord,
}

const foldOnline = (users: User[]) => fromFoldableMap(getLastSemigroup<boolean>(), array)(
    users,
    user => [user.id.toString(), !!user.is_online]
)

export const usersReducer = combineReducers<UsersState>({
    online: createReducer<BooleanRecord>({})
        .handleAction(usersActions.update, (state, action) => pipe(
            action.payload,
            filter(user => !!user.is_online),
            foldOnline,
        ))
        .handleAction([userActions.info.success, userActions.update.success], (state, action) => ({
            ...state,
            [action.payload.id]: !!action.payload.is_online,
        }))
        .handleAction(projectActions.get.success, (state, action) => ({
            ...state,
            ...foldOnline([...action.payload.users, action.payload.manager])
        }))
        .handleAction(projectActions.list.success, (state, action) => ({
            ...state,
            ...foldOnline(action.payload.projects.flatMap(project => [...project.users, project.manager])),
        }))
})